
import { EmergencyExerciseList } from "./EmergencyExerciseList";

interface EmergencyExerciseListContainerProps {
  routineId: string;
}

export const EmergencyExerciseListContainer = ({ routineId }: EmergencyExerciseListContainerProps) => {
  console.log(`🚨 EMERGENCY: Container initialized for routine ${routineId}`);
  
  return (
    <div className="w-full">
      <div className="mb-4 p-3 bg-orange-500/20 border border-orange-500/50 rounded-lg">
        <div className="text-orange-800 dark:text-orange-200 font-medium text-sm">
          🚨 Sistema de emergencia activado
        </div>
        <div className="text-orange-700 dark:text-orange-300 text-xs mt-1">
          Funcionionalidad reducida para garantizar estabilidad. Los cambios se guardan localmente y se sincronizan cuando es posible.
        </div>
      </div>
      
      <EmergencyExerciseList routineId={routineId} />
    </div>
  );
};
